// import LandingPage from './containers/LandingPage';
import TowItemsImportExport from "./containers/TowItemsImportExport";
import TowItemSelectionForm from "./containers/TowItemSelectionForm";
// import UserPreference from './components/global/UserPreference';
import ManageCompanies from "./containers/ManageCompanies";
import PageNotFound from "./containers/Error";
import TowItemPlugwrap from "./containers/TowItemPlugwrap";
import Forbidden from "./containers/Forbidden";
import InProgress from "./containers/InProgress";
import AcetateFilter from "./containers/DualAcetateFilter";
import ShareFilterCigarette from "./containers/ShareFilterCigarette";
import CompanyNotFound from "./containers/CompanyNotFound";
import ManageMessages from "./containers/ManageMessages";
import ManageUsers from "./containers/ManageUsers";
import ModelAnalyzer from "./containers/ModelAnalyzer";
import TranslationLabels from "./containers/TranslationLabels";
import ManageUsersV2 from "./containers/ManageUsersV2";
import ManageSignIns from "./containers/ManageSignIns";
import ManageAnalytics from "./containers/ManageAnalytics";
import RequestAccess from "./containers/RequestAccess";
import Heatnotburn from "./containers/heatnotburn";

const routes = [
  {
    path: "/",
    exact: true,
    component: TowItemSelectionForm,
  },
  {
    path: "/items-export-import",
    exact: true,
    component: TowItemsImportExport,
    isAdmin: true,
  },
  {
    path: "/towitemselection",
    exact: true,
    component: TowItemSelectionForm,
  },
  {
    path: "/heatnotburn",
    exact: true,
    component: Heatnotburn,
  },
  {
    path: "/sharefiltercigarette",
    exact: true,
    component: ShareFilterCigarette,
  },
  {
    path: "/company-not-found",
    exact: true,
    component: CompanyNotFound,
  },
  {
    path: "/manage-companies",
    exact: true,
    component: ManageCompanies,
    isAdmin: true,
  },
  {
    path: "/manage-messages",
    exact: true,
    component: ManageMessages,
    isAdmin: true,
  },
  {
    path: "/manage-users",
    exact: true,
    component: ManageUsers,
    isAdmin: true,
  },
  {
    path: "/request-access",
    exact: true,
    component: RequestAccess,
    isAdmin: true,
  },
  {
    path: "/manage-users-v2",
    exact: true,
    component: ManageUsersV2,
    isAdmin: true,
  },
  {
    path: "/manage-sign-ins",
    exact: true,
    component: ManageSignIns,
    isAdmin: true,
  },
  {
    path: "/manage-analytics",
    exact: true,
    component: ManageAnalytics,
    isAdmin: true,
  },
  {
    path: "/translation-labels",
    exact: true,
    component: TranslationLabels,
    isAdmin: true,
  },
  {
    path: "/model-analyzer",
    exact: true,
    component: ModelAnalyzer,
    isAdmin: true,
  },
  {
    path: "/404",
    exact: true,
    component: PageNotFound,
  },
  {
    path: "/403",
    exact: true,
    component: Forbidden,
  },
  {
    path: "/inprogress",
    exact: true,
    component: InProgress,
  },
  {
    path: "/towitem-plugwrap",
    exact: true,
    component: TowItemPlugwrap,
  },
  {
    path: "/filter-cigarette-design",
    exact: true,
    component: AcetateFilter,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js